import { Type } from "class-transformer";
import { IsDate, IsEnum, IsString } from "class-validator";
import { AbstractJSONModel } from "./master-model";
export enum eContactInformationCategory {
  Mobiltelefon = "Mobiltelefon",
  Hjemmetelefon = "Hjemmetelefon",
  Arbejdstelefon = "Arbejdstelefon",
  Arbejdsmail = "Arbejdsmail",
  Hjemmemail = "Hjemmemail",
  Default = "Default"
}
export interface IContactInformationPut {
  id: number;
  note: string;
  number_address: string;
  category: eContactInformationCategory;
}

export class ContactInformation extends AbstractJSONModel {
  public id = 0;
  @IsString()
  public note = "";
  @IsString()
  public number_address = "";
  public owner_id = 0;
  @IsString()
  public owner_type = "";
  @IsEnum(eContactInformationCategory)
  public category: eContactInformationCategory = eContactInformationCategory.Default;
  @IsDate()
  @Type(() => Date)
  public updated_at: Date = new Date();
  @IsDate()
  @Type(() => Date)
  public created_at: Date = new Date();

  public convertToPutObject(): IContactInformationPut {
    const c: IContactInformationPut = Object.assign({});
    c.id = this.id;
    c.note = this.note;
    c.number_address = this.number_address;
    c.category = this.category;
    return c;
  }
}
